import { createFileRoute } from '@tanstack/react-router';

import StorePagesPage from '@/components/store/pages/Page';

export const Route = createFileRoute('/store/pages/')({
	component: StorePagesPage,
});
